/*
 * @Author: qh_feng
 * @Date: 2022-03-17 17:22:49
 * @LastEditTime: 2022-12-12 17:09:24
 * @LastEditors: your name
 * @Description:
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:  系统管理 API
 */
export default {
  //卡口管理
  POST_tollgateAdd: '/dqi-hymanage/tollgate/add',



  //设备管理
  POST_deviceList:"/dqi-hymanage/device/page",//设备列表
  GET_deviceInfo:'/dqi-hymanage/device/info',//设备详情
  GET_deviceDel:'/dqi-hymanage/device/delete',//设备删除
  POST_deviceAdd:'/dqi-hymanage/device/add',//增加设备
  POST_deviceUpdate:'/dqi-hymanage/device/update',//修改设备
  POST_deviceImg:'/dqi-hymanage/device/addimg',//上传设备图像
  GET_deviceMapsite:'/dqi-hymanage/device/getEnableDevice',//获取地图点位
  POST_openFacedevice:'/dqi-hymanage/face/gate/openFaceDevice',//打开人脸闸机
  GET_vehicleGate:'/dqi-hymanage/vehicle/gate', //打开车辆闸机

  //卡口管理
  POST_tollgateList:'/dqi-hymanage/tollgate/page',//卡口查询列表
  GET_tollgateInfo:'/dqi-hymanage/tollgate/info',//卡口详情
  GET_tollgateDell:'/dqi-hymanage/tollgate/delete',//删除卡口
  POST_tollgateAdd:'/dqi-hymanage/tollgate/add',//增加卡口
  POST_tollgateUpdata:'/dqi-hymanage/tollgate/update',//修改卡口
  POST_tollgateImg:'/dqi-hymanage/tollgate/addimg',//上传卡口图片
  GET_tollgateAll:'/dqi-hymanage/tollgate/all',//获取所有卡口名称，id，即字典


  //资料库管理
  POST_addFile:'/dqi-hymanage/hyDatafile/addFile',//添加资料
  POST_addSort:'/dqi-hymanage/hyDatafile/addSort',//添加分类
  GET_delFile:'/dqi-hymanage/hyDatafile/delete',//删除资料
  GET_downFile:'/dqi-hymanage/hyDatafile/downloadFile',//下载资料
  GET_findSort:'/dqi-hymanage/hyDatafile/findSort',//查询分类
  POST_fileList:'/dqi-hymanage/hyDatafile/index',//查询资料
  POST_fileUpdate:'/dqi-hymanage/hyDatafile/update',//修改资料
  POST_uploadFile:'/dqi-hymanage/hyDatafile/uploadFile',//上传资料


 //安全教育管理
  POST_hySafeList:'/dqi-hymanage/hySafe/index',//安全教育查询
  POST_hySafeAddorUpdate:'/dqi-hymanage/hySafe/addOrupdate',//添加或修改安全教育
  GET_hySafeDel:'/dqi-hymanage/hySafe/delete',//删除安全教育
  GET_hySafeFind:'/dqi-hymanage/hySafe/find',//id查询内容
  POST_hySafeEnable:'/dqi-hymanage/hySafe/enable',//使公告生效或失效

  //公告管理
  POST_hyNoticeAddorUpdate:'/dqi-hymanage/hyNotice/addOrupdate',//添加或修改公告
  GET_hyNoticeDel:'/dqi-hymanage/hyNotice/delete',//删除公告
  GET_hyNoticeFind:'/dqi-hymanage/hyNotice/find',//id查询内容
  POST_hyNoticeList:'/dqi-hymanage/hyNotice/index',//公告查询列表
  POST_hyNoticeEnable:'/dqi-hymanage/hyNotice/enable',//使公告生效或失效

  //地图管控区域
  POST_controlRegionList:'/dqi-hymanage/hyControlRegion/index',
  POST_controlRegionAddOrUpdate:'/dqi-hymanage/hyControlRegion/addOrUpdate',
  GET_controlRegionDel:'/dqi-hymanage/hyControlRegion/delete',
  GET_controlRegionFind:'/dqi-hymanage/hyControlRegion/find',
  POST_controlRegionEnable:'/dqi-hymanage/hyControlRegion/enable',

  //企业联系人管理
  POST_hyContactIndex:'/dqi-hymanage/hyContact/index', //查看企业联系人
  POST_hyContactAdd:'/dqi-hymanage/hyContact/addContact',//添加企业联系人
  POST_hyContactUpdate:'/dqi-hymanage/hyContact/update',//更新企业联系人
  GET_hyContactDelete:'/dqi-hymanage/hyContact/delete/',//删除企业联系人

  //黑名单管理
  POST_vehicleBlackList:'/dqi-hymanage/vehicleBlack/getAllList', //查看黑名单列表
  POST_addVehicleBlack:'/dqi-hymanage/vehicleBlack/addByCno', //添加车牌黑名单
  GET_delVehicleBlack:'/dqi-hymanage/vehicleBlack/delete', //删除车牌黑名单
  GET_delCoIdBlack:'/dqi-hymanage/vehicleBlack/deletebyCoId', //解除企业黑名单
  GET_getCoIdBlack:'/dqi-hymanage/vehicleBlack/getHyEnterprise', //获取企业列表黑名单
  POST_delBatchCar:'/dqi-hymanage/vehicleBlack/batch/deleteCar',//批量删除车辆黑名单

  //操作日志管理
  POST_getLogList:'/dqi-hymanage/operationLog/getlogList', //查看操作日志列表
}



// WEBPACK FOOTER //
// ./src/http/apiModules/xtgl.js